export default function createHelpers(config) {
  return {
    http: config.http,
    cookies: config.cookies,
  };
}
